import type { SidebarItem } from "@/components/layout/main/AppSidebar/hooks/useSidebarActiveItems";
import { ChartPie, LayoutTemplate, SettingsIcon } from "lucide-react";
import VisitsIcons from "@/assets/icons/visits.svg?react";

export const isProduction = import.meta.env.MODE === "production";

export const topItemsSidebar: SidebarItem[] = [
  {
    title: "visits.title",
    url: "/visits",
    icon: VisitsIcons,
    disabled: false,
  },
  {
    title: "templates.title",
    url: "/templates",
    icon: LayoutTemplate,
    disabled: false,
  },
  {
    title: "dashboard.title",
    url: "/analytics",
    disabled: false,
    icon: ChartPie,
  },
] as const;

export const bottomItemsSidebar: SidebarItem[] = [
  {
    title: "settings.title",
    url: "/settings",
    icon: SettingsIcon,
    disabled: false,
  },
];

export const interfaceLanguageOptions = [
  { value: "en", label: "English", flag: "🇺🇸" },
  { value: "es", label: "Español", flag: "🇪🇸" },
  { value: "pt", label: "Português", flag: "🇧🇷" },
  { value: "fr", label: "Français", flag: "🇫🇷" },
  { value: "ja", label: "日本語", flag: "🇯🇵" },
  { value: "zh", label: "中文", flag: "🇨🇳" },
];
